import React, { Component } from "react";
import { push } from "redux-little-router";
import { connect } from "react-redux";
import { Icon, Dropdown } from "semantic-ui-react";
import {
  deletePostAsAdmin as deleteCaseAsAdmin,
  hidePostAsAdmin,
  unhidePostAsAdmin,
  floatPostAsAdmin,
} from "../../../../actions/postActions";
import { showConfirmDialog, hideConfirmDialog } from "../../../../actions";
import { constructPostSlugPath } from "../../../../util/index";
import "./index.css";

class AdminCaseActionsDropdown extends Component {
  constructor(props) {
    super(props);
    this.post = this.props.post;
    const { actions } = this.props;

    this.openDeleteConfirmDialog = this.openDeleteConfirmDialog.bind(this);
    this.deleteCurrentPostAsAdmin = this.deleteCurrentPostAsAdmin.bind(this);
    this.hideCurrentPostAsAdmin = this.hideCurrentPostAsAdmin.bind(this);
    this.unhideCurrentPostAsAdmin = this.unhideCurrentPostAsAdmin.bind(this);
    this.floatPostAsAdmin = this.floatPostAsAdmin.bind(this);
    this.openHideConfirmDialog = this.openHideConfirmDialog.bind(this);
    this.getDropdownOptions = this.getDropdownOptions.bind(this);
    this.openFloatPostConfirmationDialog = this.openFloatPostConfirmationDialog.bind(this);

    this.adminDropdownOptions = [
      {
        key: `admin_edit_${this.post._id}`,
        text: "Edit Case As Admin",
        onClick: () => actions.editCaseAsAdmin(this.post),
      },
      {
        key: `admin_delete_${this.post._id}`,
        text: "Delete Case As Admin",
        onClick: this.openDeleteConfirmDialog,
      },
      {
        key: `admin_float_${this.post._id}`,
        text: "Move case to the top",
        onClick: this.openFloatPostConfirmationDialog,
      },
    ];

    this.hidePostDropdownOption = {
      key: `admin_hide_${this.post._id}`,
      text: "Hide Case As Admin",
      onClick: this.openHideConfirmDialog,
    };

    this.unhidePostDropdownOption = {
      key: `admin_unhide_${this.post._id}`,
      text: "Unhide Case As Admin",
      onClick: this.openHideConfirmDialog,
    };
  }

  openDeleteConfirmDialog() {
    this.props.actions.showConfirmDialog({
      onConfirm: this.deleteCurrentPostAsAdmin,
      onCancel: this.props.actions.hideConfirmDialog,
      content: "Are you sure you want to delete this case?",
      confirmText: "DELETE",
      confirmColor: "red",
    });
  }

  openFloatPostConfirmationDialog() {
    this.props.actions.showConfirmDialog({
      onConfirm: this.floatPostAsAdmin,
      onCancel: this.props.actions.hideConfirmDialog,
      content: "Are you sure you want to move this case to the top of the timeline?",
      confirmText: "MOVE",
    });
  }

  openHideConfirmDialog() {
    if (this.props.post.isActive) {
      this.props.actions.showConfirmDialog({
        onConfirm: this.hideCurrentPostAsAdmin,
        onCancel: this.props.actions.hideConfirmDialog,
        content: "Are you sure you want to hide this case?",
        confirmText: "Hide",
      });
    } else {
      this.props.actions.showConfirmDialog({
        onConfirm: this.unhideCurrentPostAsAdmin,
        onCancel: this.props.actions.hideConfirmDialog,
        content: "Are you sure you want to unhide this case?",
        confirmText: "Unhide",
      });
    }
  }

  deleteCurrentPostAsAdmin() {
    this.props.actions.hideConfirmDialog();
    const isInSinglePostView = this.props.currentRoute === "/posts/:id" || this.props.currentRoute === "/case/:slug";
    const redirectionRoute = isInSinglePostView ? "/" : null;
    this.props.actions.deleteCaseAsAdmin(this.post._id, redirectionRoute);
  }

  hideCurrentPostAsAdmin() {
    this.props.actions.hideConfirmDialog();
    const isInSinglePostView = this.props.currentRoute === "/posts/:id" || this.props.currentRoute === "/case/:slug";
    const redirectionRoute = isInSinglePostView ? "/" : null;
    this.props.actions.hidePostAsAdmin(this.post._id, redirectionRoute);
  }

  unhideCurrentPostAsAdmin() {
    this.props.actions.hideConfirmDialog();
    this.props.actions.unhidePostAsAdmin(this.post._id);
  }

  floatPostAsAdmin() {
    this.props.actions.hideConfirmDialog();
    this.props.actions.floatPostAsAdmin(this.post._id);
  }

  getDropdownOptions() {
    let options = [];
    if (this.props.isOwnPost) {
      options.push(...this.props.defaultOptions);
    }
    const postHidingOption = this.props.post.isActive ? this.hidePostDropdownOption : this.unhidePostDropdownOption;
    options.push(...this.adminDropdownOptions, postHidingOption);

    return options;
  }

  render() {
    const options = this.getDropdownOptions();
    return (
      <div className="case-dropdown">
        <Dropdown
          trigger={<Icon name="ellipsis horizontal" size="large" color="grey" className="-ellipsis-nav" />}
          options={options}
          pointing="top right"
          icon={null}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentRoute: state.router.route,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      editCaseAsAdmin: post => dispatch(push(`/admin${constructPostSlugPath(post)}/edit`)),
      deleteCaseAsAdmin: (postId, redirectionRoute) => dispatch(deleteCaseAsAdmin(postId, redirectionRoute)),
      hidePostAsAdmin: (postId, redirectionRoute) => dispatch(hidePostAsAdmin(postId, redirectionRoute)),
      unhidePostAsAdmin: postId => dispatch(unhidePostAsAdmin(postId)),
      floatPostAsAdmin: postId => dispatch(floatPostAsAdmin(postId)),
      showConfirmDialog: options => dispatch(showConfirmDialog(options)),
      hideConfirmDialog: () => dispatch(hideConfirmDialog()),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminCaseActionsDropdown);



// WEBPACK FOOTER //
// ./src/components/PostsList/components/AdminCaseActionsDropdown/index.js